<template>
  <div class="capture">
    <div class="capture-dialog" v-if="captureDialog">
      <div class="mask"></div>
      <div class="capture-list">
        <template v-if="playVideoList.length > 0">
          <div
            class="capture-sel"
            v-for="(item, index) in playVideoList"
            :key="item.id"
            @click="getVideoPic(index)"
          >
            <span>选择该视频源上报隐患</span>
          </div>
        </template>
        <template v-if="noPlayVideoList.length > 0">
          <div
            class="capture-sel"
            v-for="(value, key) in noPlayVideoList"
            :key="key"
          >
          </div>
        </template>
      </div>
      <div class="cancel" @click="cancel()">取消上报</div>
    </div>
    <capture-report-hidden :captureImg="captureImg"></capture-report-hidden>
  </div>
</template>
<script>
import captureReportHidden from "./captureReportHidden";
export default {
  name: "monitorCapture",
  components: {
    captureReportHidden
  },
  props: {
    playVideoList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    noPlayVideoList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      captureDialog: false,
      captureImg: ""
    };
  },
  created() {},
  mounted() {},
  computed: {
    captureResize() {
      return this.$store.state.captureResize;
    }
  },
  watch: {
    captureResize(newVal) {
      if (newVal) {
        this.captureDialog = true;
      }
    }
  },
  methods: {
    cancel() {
      this.captureDialog = false;
    },
    getVideoPic(id) {
      if (this.playVideoList[id].playStatus == false) {
        this.$message({
          type: "warning",
          message: "请先播放监控"
        });
        return false;
      }
      // console.log(this.$parent.$refs[`tcplayer${id}`][0].$refs.tcplayer.children[0].children)
      // return
      let childaArray = this.$parent.$refs[`tcplayer${id}`][0].$refs.tcplayer
        .children[0].children;
      let childIndex;
      // console.log(childaArray);
      childaArray.forEach((element, index) => {
        // console.log(element);
        if (element.tagName == "VIDEO") {
          childIndex = index;
        }
      });
      // console.log(childIndex);
      // let video = document.getElementById("tcplayer" + childIndex).children[0].children[
      //   childIndex
      // ];
      let video = this.$parent.$refs[`tcplayer${id}`][0].$refs.tcplayer
        .children[0].children[childIndex];

      // console.log(video);
      // return

      let canvas = document.createElement("canvas");
      let w = window.innerWidth;

      let h = (window.innerWidth / 16) * 9;
      canvas.width = w;
      canvas.height = h;
      // console.log(canvas);
      const ctx = canvas.getContext("2d");

      ctx.drawImage(video, 0, 0, w, h);
      ctx.drawImage(video, 0, 0, w, h);
      this.previewImg = canvas.toDataURL("image/png");
      var img = new Image();
      img.src = this.previewImg;
      // var imageData = this.$Common.convertBase64UrlToBlob(img.src)
      var fileName = new Date().getTime() + ".png";
      var imageData = this.$Common.base64ToFile(img.src, fileName);
      this.imgUpload(imageData);
      // console.log(uploadFile)
      // document.body.appendChild(img);
    },
    // 图片上传
    async imgUpload(event) {
      var uploadInfo = await this.$Common.fileUpload(event, 2);
      if (uploadInfo) {
        this.captureDialog = false;
        this.captureImg = uploadInfo.fileUrl;
        // console.log(uploadInfo.fileUrl)
      }
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.capture {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.capture-dialog {
  width: 100%;
  height: 250px;
  position: absolute;
  left: 0;
  right: 0;
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 11;
  }
  .capture-list {
    width: 100%;
    height: 220px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 16px;
    left: 0;
    z-index: 12;
  }
  .capture-sel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 445px;
    height: 250px;
    border: 3px solid #1354d6;
    cursor: pointer;
    &:hover {
      span {
        display: block;
      }
    }
    span {
      display: none;
      color: #fff;
      font-size: 18px;
    }
  }
  .cancel {
    padding: 5px 10px;
    background: #1354d6;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    position: absolute;
    right: -20px;
    bottom: -20px;
    z-index: 13;
  }
}
</style>
